<template>
    <div v-if="bizAuth.editHouse.hasRight" class="biz-edit-house-page">
        <edit-house-comp :class="{'fixed': listIsFixed}"></edit-house-comp>
    </div>
</template>
<script>
import EditHouseComp from '@/components/bussiness/mgtCategory/houseMgt/addHouse/EditHouseComp.vue';
import { mapGetters } from 'vuex'

export default {
    name: 'editHouse',
    data () {
        return {
            listIsFixed: false
        }
    },
    mounted () {
        window.addEventListener('scroll', this.handleScroll);
    },
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
        document.getElementsByClassName('biz-tool-bar-wrap')[0].style.display = 'flex'
    },
    watch: {
        'bizAuth.editHouse.hasRight': function (val) {
            if(!val){
                this.$store.dispatch('setModalStatus', {state: true, type: 'bizNoRight'})
            }
        }
    },
    methods: {
        handleScroll: function () {
            let scrollTop = event.target.documentElement.scrollTop
            // console.log(scrollTop)
            if( scrollTop >= 50){
                document.getElementsByClassName('biz-tool-bar-wrap')[0].style.display = 'none'
                document.getElementsByClassName('page-header')[0].style.zIndex = '8'
            }else{
                document.getElementsByClassName('biz-tool-bar-wrap')[0].style.display = 'flex'
                document.getElementsByClassName('page-header')[0].style.zIndex = '8'
                this.listIsFixed = false
            }

            if( scrollTop >= 115){
                this.listIsFixed = true
            }
        },
    },
    computed: {
        ...mapGetters({
            bizAuth: 'GET_BIZ_AUTH',
        })
    },
    components: {
        EditHouseComp
    }
}
</script>
<style lang="scss" scoped>
    .biz-edit-house-page{
        position: relative;
    }
</style>


// WEBPACK FOOTER //
// src/pages/bussiness/mgtCategory/houseMgt/EditHouse.vue